import type { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

type ShimmerContainerProps = {
  children?: ReactNode;
  className?: string;
  isInactive?: boolean;
  testId?: string;
};

export default function ShimmerContainer({ children, className, isInactive, testId }: ShimmerContainerProps) {
  return (
    <div className={classNames(styles.container, className)} data-testid={testId}>
      {children}
      {isInactive ? null : <div className={styles.ripple} />}
    </div>
  );
}
